import { useVendorContext } from "@client-shared/providers/vendor";
import { useMemo } from "react";
import { useDemoDataModule } from "./use-demo-data-module";
import type { DemoBatches } from "./batches.demo";

const loadBatchesDemo = () => Promise.all([import("./batches.demo"), import("./orders.demo")]);

const FALLBACK_ACCOUNT_NUMBER = "DEMO-ACCOUNT";
const FALLBACK_COUNTRY_CODE = "US";

export interface DemoBatchesView extends Partial<DemoBatches> {
  /** True for the one tick while the fixtures load */
  isLoading: boolean;
}

/** Sample batches (and the first batch's detail) while the tour runs; undefined in normal use */
export function useDemoBatches(): DemoBatchesView | undefined {
  const { isActive, module } = useDemoDataModule(loadBatchesDemo);
  const [{ currentVendor, customerAccountCarrierDetails }] = useVendorContext();
  const customerAccountNumber = customerAccountCarrierDetails?.[0]?.customerAccountNumber.split(",")[0]?.trim() ?? FALLBACK_ACCOUNT_NUMBER;
  const countryCode = currentVendor?.countryCode ?? FALLBACK_COUNTRY_CODE;

  return useMemo(() => {
    if (!isActive) return undefined;
    if (!module) return { isLoading: true };
    const [batchesDemo, ordersDemo] = module;
    const orders = ordersDemo.buildDemoOrders({ customerAccountNumber, countryCode });
    return { ...batchesDemo.buildDemoBatches({ orders }), isLoading: false };
  }, [isActive, module, customerAccountNumber, countryCode]);
}
